export enum MessageType {
  Appointment = "appointment",
}
